<template>
  <section>
    <header>
      <slot name="title">
        <h1>{{ title }}</h1>
      </slot>
    </header>
    <div>
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
header {
  width: 100%;
  padding: 0;
  margin-bottom: 1rem;
  box-sizing: border-box;
  display: flex;
}

h1 {
  color: #2d313d;
  font-size: 1.5rem;
  font-weight: 700;
  text-transform: uppercase;
  position: relative;
  &:after {
    position: absolute;
    height: 3px;
    width: 80px;
    background-color: var(--theme-primary);
    bottom: 0px;
    text-align: center;
    content: '';
    // margin: 0 auto;
    right: 0;
    left: 0;
  }
}
</style>
